package com.parmartechnologies.storage.table.employee

import com.parmartechnologies.core.feature.employee.model.Employee
import com.parmartechnologies.storage.collection.DatabaseCollection
import com.parmartechnologies.storage.table.DatabaseTable

class EmployeeDatabaseTable : DatabaseTable() {
    fun insert(item: Employee) {
        DatabaseCollection().insert(item, Employee.serializer())
    }

    fun insert(items: List<Employee>?) {
        DatabaseCollection().insertAll(items ?: listOf(), Employee.serializer())
    }

    fun retrieve(id: String, callback: (List<Employee>) -> Unit) {

    }

    fun retrieveForBusiness(id: String, callback: (List<Employee>) -> Unit) {
        DatabaseCollection().findAllByBusinessId(id,Employee.serializer()){
            callback(it)
        }
    }
}